import React, { Component } from "react";
import "../../css/toastView.css";
 
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
 
import "react-tabs/style/react-tabs.css";
 
const icon1 = "https://winpeforum.com/assets/elements/Clarence_Anthony.jpg.jpg";
 
const icon2 = "https://winpeforum.com/assets/elements/VT.jpg";
const icon3 = "https://winpeforum.com/assets/elements/Kunal_Gupta.jpg";
const icon4 = "https://winpeforum.com/assets/elements/Upasana-Edge.jpg";
const icon5 = "https://winpeforum.com/assets/elements/Puncham.jpg";
const icon6 = "https://winpeforum.com/assets/elements/Harsh_Jain.JPG"; 
const icon7 = "https://winpeforum.com/assets/elements/ashutosh.png"; 
let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class WinPEEdge extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isShow: false,
  //     activeItem: {},
  //   };
  // }

  // togglePopUp = (item) => {
  //   this.setState({
  //     isShow: !this.state.isShow,
  //     activeItem: item || {},
  //   });
  // };
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.tabContent = [
      {
        id: 0,
        title: "Quarter 1",
      },
      {
        id: 1,
        title: "Quarter 2",
      },
      {
        id: 2,
        title: "Quarter 3",
      },
      {
        id: 3,
        title: "Quarter 4",
      },
    ];
  
   
 
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };

  

  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
      <Meta
      title="Winpe Event Calendar 2023-24"
      image={"https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"}
      description=" "
      location={location}
    />
      <div className="section__content" style={{defaultStyle, paddingBottom:"25%"}}>
     <div className="toastshine_wrapper" style={{}}>
     
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div> 
   
      
        <h1 className="ignite-ask-me-anything__heading">Event Calendar 2026-27</h1>
        
           
        <hr className="ignite-ask-me-anything__hr"></hr>
         
      
   
  <center><div className="tab_section container">
   
  <ul class="nav nav-tabs justify-content-center" role="tablist" style={{display: "inline-block"}}>
	<li class="nav-item">
		<a class="nav-link  " data-toggle="tab" href="#tabs-1" role="tab" style={{padding: "10px 5px"}}> <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Quarter 1&nbsp;   </h4> </a>
	</li>
	<li class="nav-item">
		<a class="nav-link  active " data-toggle="tab" href="#tabs-2" role="tab" style={{padding: "10px 5px"}}><h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Quarter 2 &nbsp;  </h4> </a>
	</li>
	<li class="nav-item ">
		<a class="nav-link " data-toggle="tab" href="#tabs-3" role="tab" style={{padding: "10px 5px"}}><h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Quarter 3&nbsp; </h4> </a>
	</li>
    <li class="nav-item ">
		<a class="nav-link " data-toggle="tab" href="#tabs-4" role="tab" style={{padding: "10px 5px"}}><h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Quarter 4&nbsp; </h4> </a>
	</li>
</ul> 
<div class="tab-content" >
	<div class="tab-pane  " id="tabs-1" role="tabpanel"><br/><br/><br/>
 
    <img src="https://winpeforum.com/assets/Q1-126.png" style={{width: "100%" }}/>
      
	</div>
	<div class="tab-pane  active" id="tabs-2" role="tabpanel"><br/><br/><br/>
    <img src="https://winpeforum.com/assets/Q2-126.png" style={{width: "100%"}}/>
	</div>
	<div class="tab-pane  " id="tabs-3" role="tabpanel"><br/><br/><br/>
    <img src="https://winpeforum.com/assets/Q326.png" style={{width: "100%"}}/>
	</div>
    <div class="tab-pane  " id="tabs-4" role="tabpanel"><br/><br/><br/>
    <img src="https://winpeforum.com/assets/Q426.png" style={{width: "100%"}}/>
	</div>
</div>

               
                </div></center>
           

         
        
<br/>    
<br />

                <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
      </div></div>
      </ContentPage>
    );
  }
}




WinPEEdge.propTypes = {
  location: PropTypes.object,
};

export default WinPEEdge;
 


// WEBPACK FOOTER //
// ./src/pages/event-calendar/index.js